module.exports = __webpack_public_path__ + "img/huanbao.2e354c68.png";